import React from "react"
import * as styles from "./spinner.module.scss"
import { SpinnerPropsType } from "./types"

export default function Spinner({ color, size, className }: SpinnerPropsType) {
  return (
    <div
      className={`${styles.spinnerWrapper}${className ? ` ${className}` : ""}`}
    >
      <div
        className="spinner"
        style={{
          border: `5px solid ${color ? color : "white"}`,
          width: size ? size : 45,
          height: size ? size : 45,
        }}
      ></div>
    </div>
  )
}
